import React from 'react';
import { PhoneAnswerRate } from './PhoneAnswerRate';
import { PhoneNumber } from './PhoneNumber';
import btnIcons from '@/shared/assets/sprites/btns.sprite.svg';
import type { PhoneCardProps } from '../model/types';
export const PhoneCard: React.FC<PhoneCardProps> = ({
  phoneNumber,
  onCall
}) => {
  return <a href={`tel:${phoneNumber.phone}`} className="relative flex items-center justify-center rounded-2xl bg-bgSecondary p-3 transition-all hover:bg-black/5" onClick={onCall} data-sentry-component="PhoneCard" data-sentry-source-file="PhoneCard.tsx">
      <div aria-hidden="true" className="absolute left-5 top-1/2 flex -translate-y-1/2 items-center justify-center">
        <svg className="size-6" data-sentry-element="svg" data-sentry-source-file="PhoneCard.tsx">
          <use xlinkHref={`${btnIcons}#phone`} data-sentry-element="use" data-sentry-source-file="PhoneCard.tsx"></use>
        </svg>
      </div>
      <span className="flex flex-col gap-1">
        <PhoneNumber phone={phoneNumber.phone} data-sentry-element="PhoneNumber" data-sentry-source-file="PhoneCard.tsx" />
        <PhoneAnswerRate percentage={phoneNumber.answerRatePercentage} data-sentry-element="PhoneAnswerRate" data-sentry-source-file="PhoneCard.tsx" />
      </span>
    </a>;
};